import LogoBar from './LogoBar';

export default LogoBar;